import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-item"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "sidenav-mini-icon"
};
const _hoisted_4 = {
  class: "sidenav-normal"
};
const _hoisted_5 = {
  class: "nav nav-sm flex-column"
};
import { ref } from 'vue';

// props 정의

export default {
  __name: 'SidenavCollapseItem',
  props: {
    refer: {
      type: String,
      required: true
    },
    miniIcon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const isExpanded = ref(false);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("li", _hoisted_1, [_createElementVNode("a", {
        class: "nav-link",
        "data-bs-toggle": "collapse",
        "aria-expanded": "false",
        href: `#${__props.refer}`,
        onClick: _cache[0] || (_cache[0] = $event => isExpanded.value = !isExpanded.value)
      }, [_createElementVNode("span", _hoisted_3, _toDisplayString(__props.miniIcon), 1), _createElementVNode("span", _hoisted_4, [_createTextVNode(_toDisplayString(__props.text) + " ", 1), _cache[1] || (_cache[1] = _createElementVNode("b", {
        class: "caret"
      }, null, -1))])], 8, _hoisted_2), _createElementVNode("div", {
        class: _normalizeClass(isExpanded.value ? 'collapse show' : 'collapse')
      }, [_createElementVNode("ul", _hoisted_5, [_renderSlot(_ctx.$slots, "nav-child-item")])], 2)]);
    };
  }
};